/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_License_LabelInputs */

const en_fc_cmp_license_label = /** @type {(inputs: Fc_Cmp_License_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License`)
};

/**
* | output |
* | --- |
* | "License" |
*
* @param {Fc_Cmp_License_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_license_label = /** @type {((inputs?: Fc_Cmp_License_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_License_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_license_label(inputs)
});
export { fc_cmp_license_label as "fc.cmp.license.label" }